module.exports = __webpack_public_path__ + "media/banners/finansowanie-banner-f6ff9583.svg";